// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_p8-0";
export var buttonContainer = "_p8-3";
export var cancelButton = "_p8-4";
export var headerSection = "_p8-6";
export var headerTitle = "_p8-9";
export var messageSideLeft = "_p8-1";
export var messageSideRight = "_p8-2";
export var orderNumberContainer = "_p8-7";
export var orderNumberLabel = "_p8-8";
export var submitButton = "_p8-5";